// extracted by mini-css-extract-plugin
module.exports = {"buttonCart":"bz_j4","buttonCart_buttonanimated":"bz_j5","buttonCart__link":"bz_j6","buttonCart__counter":"bz_j7","buttonCart__counter_counteranimated":"bz_j8"};